export default {"src":"/_next/static/media/0x5d3a536e4d6dbd6114cc1ead35777bab948e3643.73eec02b.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};